// extracted by mini-css-extract-plugin
export default {"label":"InfoLabel_label__wg4Qz"};